"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _ToggleSwitchLabel = _interopRequireDefault(require("./ToggleSwitchLabel"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var COLORS = {
  NORMAL: 'greyLight',
  DISABLED: 'frenchGray'
};
var SWITCHER_SIZE = {
  HEIGHT: 65,
  WIDTH: 32
};

var ToggleSwitch = function ToggleSwitch(_ref) {
  var id = _ref.id,
      disabled = _ref.disabled,
      selected = _ref.selected,
      _onChange = _ref.onChange,
      labelOn = _ref.labelOn,
      labelOff = _ref.labelOff,
      icon = _ref.icon,
      className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement(StyledToggleSwitch, {
    className: className,
    active: selected,
    disabled: disabled
  }, /*#__PURE__*/_react["default"].createElement(FakeInput, {
    id: id,
    onChange: function onChange() {
      return _onChange(!selected);
    },
    disabled: disabled,
    checked: selected
  }), /*#__PURE__*/_react["default"].createElement(StyledLabel, {
    htmlFor: id
  }, /*#__PURE__*/_react["default"].createElement(StyledButtonContainer, null, /*#__PURE__*/_react["default"].createElement(StyledIconContainer, {
    active: selected,
    disabled: disabled
  }, icon), /*#__PURE__*/_react["default"].createElement(StyledButton, null)), (labelOn || labelOff) && /*#__PURE__*/_react["default"].createElement(StyledLabelsContainer, null, /*#__PURE__*/_react["default"].createElement(StyledToggleSwitchLabel, {
    isActive: selected
  }, labelOn), /*#__PURE__*/_react["default"].createElement(StyledToggleSwitchLabel, {
    isActive: !selected
  }, labelOff))));
};

var StyledButtonContainer = _styledComponents["default"].div.withConfig({
  displayName: "ToggleSwitch__StyledButtonContainer",
  componentId: "sc-ek9sc8-0"
})(["position:relative;border-radius:20px;cursor:pointer;height:", "px;box-sizing:border-box;border:1px solid;border-color:", ""], SWITCHER_SIZE.HEIGHT, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors[COLORS.NORMAL];
});

var StyledButton = _styledComponents["default"].div.withConfig({
  displayName: "ToggleSwitch__StyledButton",
  componentId: "sc-ek9sc8-1"
})(["display:block;border-radius:50%;margin-left:-1px;height:", "px;width:", "px;margin-top:", "px;background-color:", ";box-shadow:0 3px 3px 0 rgba(180,180,180,0.49);transition:all 0.1s;box-sizing:border-box;"], SWITCHER_SIZE.WIDTH, SWITCHER_SIZE.WIDTH, SWITCHER_SIZE.WIDTH, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.white;
});

var StyledLabel = _styledComponents["default"].label.withConfig({
  displayName: "ToggleSwitch__StyledLabel",
  componentId: "sc-ek9sc8-2"
})(["min-height:100%;display:flex;align-items:center;"]);

var StyledLabelsContainer = _styledComponents["default"].div.withConfig({
  displayName: "ToggleSwitch__StyledLabelsContainer",
  componentId: "sc-ek9sc8-3"
})(["margin-left:10px;min-height:", "px;display:flex;flex-direction:column;justify-content:space-between;>:first-child{margin-bottom:10px;}"], SWITCHER_SIZE.HEIGHT);

var FakeInput = _styledComponents["default"].input.attrs({
  type: 'checkbox'
}).withConfig({
  displayName: "ToggleSwitch__FakeInput",
  componentId: "sc-ek9sc8-4"
})(["display:none;"]);

var StyledToggleSwitchLabel = (0, _styledComponents["default"])(_ToggleSwitchLabel["default"]).withConfig({
  displayName: "ToggleSwitch__StyledToggleSwitchLabel",
  componentId: "sc-ek9sc8-5"
})([""]);

var StyledIconContainer = _styledComponents["default"].div.withConfig({
  displayName: "ToggleSwitch__StyledIconContainer",
  componentId: "sc-ek9sc8-6"
})(["position:absolute;display:flex;align-items:center;justify-content:center;height:20px;width:20px;top:6px;left:16px;transform:translateX(-50%);transition:all 0.3s;>*:first-child{width:100%;height:100%;}"]);

var StyledToggleSwitch = _styledComponents["default"].div.withConfig({
  displayName: "ToggleSwitch__StyledToggleSwitch",
  componentId: "sc-ek9sc8-7"
})(["position:relative;", " ", ""], function (_ref4) {
  var disabled = _ref4.disabled,
      theme = _ref4.theme;
  return disabled && (0, _styledComponents.css)(["", "{box-shadow:none;background:none;}", ",", "{border:1px solid ", ";}", "{color:", "}"], StyledButton, StyledButtonContainer, StyledButton, theme.colors[COLORS.DISABLED], StyledToggleSwitchLabel, theme.colors[COLORS.DISABLED]);
}, function (_ref5) {
  var active = _ref5.active;
  return active && (0, _styledComponents.css)(["", "{margin-top:-1px;background:linear-gradient(to bottom,#1f80f1,#5ac9f5);box-shadow:0 0 20px 0 #00a6e3;border:none;}"], StyledButton);
});

ToggleSwitch.COLORS = COLORS;
ToggleSwitch.PinComponent = StyledButton;
ToggleSwitch.propTypes = {
  id: _propTypes["default"].string.isRequired,
  onChange: _propTypes["default"].func.isRequired,
  className: _propTypes["default"].string,
  labelOn: _propTypes["default"].string,
  labelOff: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  selected: _propTypes["default"].bool,
  icon: _propTypes["default"].node
};
ToggleSwitch.defaultProps = {
  className: '',
  labelOn: null,
  labelOff: null,
  disabled: false,
  selected: false,
  icon: null
};
var _default = ToggleSwitch;
exports["default"] = _default;